import React, { useState, useRef, useEffect } from "react"
import { HeaderBackTitle } from "../common/header"
import { TyreListByBrand, PopularTyreBrands } from "."
import ScrollContainer from "react-indiana-drag-scroll"
import { FiX } from "react-icons/fi";
import { _getAllTyreTopList, _generateTyreFilterToUrl } from "../../libraries/common"
import _ from "lodash"
import { useRouter } from "next/router"
import Link from 'next/link';
import { pageLink } from "../../config/site"
import Redux from "@/action";
import { Footer } from "../common/footer"
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { MyBody } from "../body/body";
import { CustomLink } from "../app/customLink";

const tagDefaultList = {
    body_type: [
        {value: 'sedan', label: 'Sedan'},
        {value: 'hatchback', label: 'Hatchback'},
        {value: 'suv', label: 'SUV'},
        {value: 'cabriolet', label: 'Cabriolet'},
        {value: 'sport', label: 'Sport'},
        {value: 'mpv', label: 'MPV'},
        {value: 'truck', label: 'Truck'},
        {value: 'wagon', label: 'Wagon'},
        {value: 'pickup', label: 'Pickup'}
    ],
    rim_diameter: [
        {value: '15', label: '15"'},
        {value: '16', label: '16"'},
        {value: '17', label: '17"'},
        {value: '18', label: '18"'},
        {value: '19', label: '19"'},
        {value: '20', label: '20"'},
        {value: '21', label: '21"'},
        {value: '22', label: '22"'},
        {value: '23', label: '23"'},
        {value: '24', label: '24"'},
        {value: '25', label: '25"'},
        {value: '26', label: '26"'},
        {value: '27', label: '27"'}
    ],
    driving_experience: [
        {value: 'ev', label: 'EV'},
        {value: 'comfort', label: 'Comfort'},
        {value: 'suv', label: 'SUV'},
        {value: 'sport', label: 'Sport'},
        {value: 'track_performance', label: 'Track & Performance'},
        {value: 'commercial', label: 'Commercial'}
    ]
}

export const TyreFilterResult = (props) => {
    const { t, device, session, params, query, fetchedData } = props
    const { store, dispatch } = Redux();
    const [loading, setLoading] = useState(true);
    const [filterType, setFilterType] = useState(_.omit(fetchedData?.request, 'tyre').search_type ?? 'by_all');
    const [filter, setFilter] = useState({});
    const router = useRouter()
    const tagList = {
        ...tagDefaultList,
        model: _.map(fetchedData?.vehicleModelList, (item) => {
            return { value: item.model_custom_url, label: item.name };
        })
    }
    // console.log(filter);
    // console.log(fetchedData.filterResult)

    const _removeSpecClick = () => {
        setFilter({});
        setFilterType('');
        router.push(pageLink.tyre.filterResult);
    }

    const _removeFilterVehicleClick = (value, type) => {
        let newFilter = {}
        let filterData = [...filter[type]];
        if(_.includes(filter[type], value?.value)){
            // remove value then already inside array
            filterData = _.filter(filter[type], (item) => item != value?.value);
        }

        newFilter = { ...filter, [type]: filterData };

        let filterLink = _generateTyreFilterToUrl(newFilter, filterType);
        if (!_.isEmpty(filterLink)) {
            filterLink = '?'+filterLink;
        }
        router.push(pageLink.tyre.filterResult+filterLink)
    }

    useEffect(()=>{
        let isMounted = true; // Flag to track component mount status

        const fetchData = async() => {
            try{
                if(store?.path?.dataAllTyreTopList == undefined){
                    await _getAllTyreTopList(dispatch);
                }
            } catch(error) {
                console.log(error)
            } finally {
                if (isMounted) {
                    // Only update state if the component is still mounted
                    setLoading(false);
                }
            }
        }
        fetchData();
        return () => {
            isMounted = false; // Mark the component as unmounted
        };
    },[])

    useEffect(()=>{
        if(filterType == 'by_spec'){
            setFilter(_.omit(fetchedData?.request, 'tyre'));
        }
        else if(filterType == 'by_filter' || filterType == 'by_vehicle') {
            let queryList = []
            queryList = _.mapValues(_.omit(fetchedData?.request, 'tyre'), (value, key) => {
                return value.split(',');
            });
            setFilter(queryList); 
        }
        else {
            // Do Nothing
        }
    },[query])

    return (
        <>
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBackTitle 
                        title={t("tyre_filter")} 
                        showSearch={false}
                        showMenu={false}
                        t={t}
                        // routerBack={pageLink.tyre.filter}
                    />
                }
                navigationComponent={
                    <div className="vehicleFilterResult_bottom containerPadding">
                        <CustomLink href={pageLink.tyre.filter}>
                            <div className="vehicleFilter_bottomNavigation_search cursorPointer">
                                <p className="fontSize_16 fontWeight_bold fontColor_white">
                                    {t('filter')}
                                </p>
                            </div>
                        </CustomLink>
                    </div>
                }
            >
                <div className="vehicleFilterResult_matchesFoundBox containerPadding">
                    <p className="fontSize_18">
                        {`${fetchedData?.filterResult.total} ${t('matches_found')}`}
                    </p>
                </div>
                <ScrollContainer className="vehicleFilterResult_searchFilterList">
                    <div className="vehicleFilterResult_searchFilterWrap containerPadding">
                        <CustomLink href={pageLink.tyre.filterResult}>
                            <div className="vehicleFilterResult_searchFilterItem">
                                <p className="fontSize_14 fontColor_white vehicleFilterResult_searchFilterItem_text">
                                    {t('clear_all')}
                                </p>
                            </div>
                        </CustomLink>
                        {
                            filterType == 'by_spec' && 
                            <React.Fragment>
                                <div className="vehicleFilterResult_searchFilterItem">
                                    <FiX onClick={()=>{_removeSpecClick()}} className='vehicleFilterResult_searchFilterItem_closeIcon cursorPointer'/>
                                    <p className="fontSize_14 fontColor_white vehicleFilterResult_searchFilterItem_text">
                                        {filter.width}/{filter.aspect_ratio} R{filter.rim_diameter}
                                    </p>
                                </div>
                            </React.Fragment>
                        }
                        {
                            (filterType == 'by_filter' || filterType == 'by_vehicle') &&
                            _.reduce(filter,( result, value, key )=>{
                                result.push(
                                    <React.Fragment key={key}>
                                        {
                                            key != 'search_type' &&
                                            _.reduce(value, (result2, value2, key2) => {
                                                let currentValue = {}
                                                currentValue = _.find(tagList[key], { value: value2 })

                                                if(!_.isEmpty(currentValue)){
                                                    result2.push(
                                                        <div key={key2} className="vehicleFilterResult_searchFilterItem">
                                                            <FiX onClick={()=>{_removeFilterVehicleClick(currentValue, key)}} className='vehicleFilterResult_searchFilterItem_closeIcon cursorPointer'/>
                                                            <p className="fontSize_14 fontColor_white vehicleFilterResult_searchFilterItem_text">
                                                                {_.capitalize(currentValue.label)}
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                                return result2
                                            }, [])
                                        }
                                    </React.Fragment>
                                )
                                return result
                            },[])
                        }
                    </div>
                </ScrollContainer>
                <div className="vehicleFilterResult_vehicleListByBrandOuter">
                    <TyreListByBrand data={fetchedData?.filterResult.tyreList} t={t} />
                </div>
                <div className="vehicleFilterResult_placementBannerMargin">
                </div>
                <div className="vehicleBrandsPopularCarMargin">
                    <PopularTyreBrands data={store?.path?.dataAllTyreTopList?.brand ?? []} isSingleRow={false} t={t} loading={store?.path?.dataAllTyreTopList == undefined ? true : false} isTyreDetail={true} />
                </div>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         {/* <AllMeta
    //             title={t('tyreFilterResultPage_meta_title')}
    //             description={t('tyreFilterResultPage_meta_description')}
    //             keyword={t('tyreFilterResultPage_meta_keyword')}
    //         />
    //         <Head><title>{t('tyreFilterResultPage_title')}</title></Head> */}
    //         <div className='bodyContainer'>
    //             <div className='contentContainer bodyContainerHasBottomNavigation'>
    //                 <HeaderBackTitle 
    //                     title={t("tyre_filter")} 
    //                     showSearch={false}
    //                     showMenu={false}
    //                     t={t}
    //                     // routerBack={pageLink.tyre.filter}
    //                 />
    //                 <div className="vehicleFilterResult_matchesFoundBox containerPadding">
    //                     <p className="fontSize_18">
    //                         {`${fetchedData?.filterResult.total} ${t('matches_found')}`}
    //                     </p>
    //                 </div>
    //                 <ScrollContainer className="vehicleFilterResult_searchFilterList">
    //                     <div className="vehicleFilterResult_searchFilterWrap containerPadding">
    //                         <Link href={pageLink.tyre.filterResult}>
    //                             <div className="vehicleFilterResult_searchFilterItem">
    //                                 <p className="fontSize_14 fontColor_white vehicleFilterResult_searchFilterItem_text">
    //                                     {t('clear_all')}
    //                                 </p>
    //                             </div>
    //                         </Link>
    //                         {
    //                             filterType == 'by_spec' && 
    //                             <React.Fragment>
    //                                 <div className="vehicleFilterResult_searchFilterItem">
    //                                     <FiX onClick={()=>{_removeSpecClick()}} className='vehicleFilterResult_searchFilterItem_closeIcon cursorPointer'/>
    //                                     <p className="fontSize_14 fontColor_white vehicleFilterResult_searchFilterItem_text">
    //                                         {filter.width}/{filter.aspect_ratio} R{filter.rim_diameter}
    //                                     </p>
    //                                 </div>
    //                             </React.Fragment>
    //                         }
    //                         {
    //                             (filterType == 'by_filter' || filterType == 'by_vehicle') &&
    //                             _.reduce(filter,( result, value, key )=>{
    //                                 result.push(
    //                                     <React.Fragment key={key}>
    //                                         {
    //                                             key != 'search_type' &&
    //                                             _.reduce(value, (result2, value2, key2) => {
    //                                                 let currentValue = {}
    //                                                 currentValue = _.find(tagList[key], { value: value2 })

    //                                                 if(!_.isEmpty(currentValue)){
    //                                                     result2.push(
    //                                                         <div key={key2} className="vehicleFilterResult_searchFilterItem">
    //                                                             <FiX onClick={()=>{_removeFilterVehicleClick(currentValue, key)}} className='vehicleFilterResult_searchFilterItem_closeIcon cursorPointer'/>
    //                                                             <p className="fontSize_14 fontColor_white vehicleFilterResult_searchFilterItem_text">
    //                                                                 {_.capitalize(currentValue.label)}
    //                                                             </p>
    //                                                         </div>
    //                                                     )
    //                                                 }
    //                                                 return result2
    //                                             }, [])
    //                                         }
    //                                     </React.Fragment>
    //                                 )
    //                                 return result
    //                             },[])
    //                         }
    //                     </div>
    //                 </ScrollContainer>
    //                 <div className="vehicleFilterResult_vehicleListByBrandOuter">
    //                     <TyreListByBrand data={fetchedData?.filterResult.tyreList} t={t} />
    //                 </div>
    //                 <div className="vehicleFilterResult_placementBannerMargin">
    //                 </div>
    //                 <div className="vehicleBrandsPopularCarMargin">
    //                     <PopularTyreBrands data={store?.path?.dataAllTyreTopList?.brand ?? []} isSingleRow={false} t={t} loading={store?.path?.dataAllTyreTopList == undefined ? true : false} isTyreDetail={true} />
    //                 </div>
    //                 <Footer t={t} />
    //             </div>
    //             <div className="vehicleFilterResult_bottom containerPadding">
    //                 <Link href={pageLink.tyre.filter}>
    //                     <div className="vehicleFilter_bottomNavigation_search cursorPointer">
    //                         <p className="fontSize_16 fontWeight_bold fontColor_white">
    //                             {t('filter')}
    //                         </p>
    //                     </div>
    //                 </Link>
    //             </div>
    //         </div>
    //     </>
    // )
}